import React from "react";
import { useRootAppStore } from "@hooks";
import { observer } from "mobx-react";
import { SharedLoaderSpinner } from "@components/loader/shared";

export default observer(function ChatLoader() {
	const { chatViewStore } = useRootAppStore();

	if (!chatViewStore?.shouldRenderMainLoader) {
		return null;
	}

	return (
		<div className="chat__loader">
			<SharedLoaderSpinner />
		</div>
	);
});
